const rdsCallbackHosts: Record<string, string> = {
    int: "paymentsredirectionservice.cp.microsoft-int.com",
    ppe: "paymentsredirectionservice.cp.microsoft.com",
    prod: "paymentsredirectionservice.cp.microsoft.com",
};

function containsControlCharacters(value: string): boolean {
    return Array.from(value).some((character) => {
        const characterCode = character.charCodeAt(0);
        return characterCode <= 31 || characterCode === 127;
    });
}

export type RdsCallbackValidationFailure =
    | "MissingRdsSessionId"
    | "InvalidRdsSessionId"
    | "UnsupportedEnvironment";

type RdsCallbackResult =
    | { callbackUrl: string; rdsSessionId: string; failureReason?: never }
    | {
        callbackUrl: null;
        rdsSessionId: null;
        failureReason: RdsCallbackValidationFailure;
    };

export function buildRdsCallbackUrl(
    sessionId: string,
    env: string,
    queryParameters: Record<string, string> = {}
): RdsCallbackResult {
    if (!sessionId || !sessionId.trim()) {
        return {
            callbackUrl: null,
            rdsSessionId: null,
            failureReason: "MissingRdsSessionId",
        };
    }

    if (containsControlCharacters(sessionId)) {
        return {
            callbackUrl: null,
            rdsSessionId: null,
            failureReason: "InvalidRdsSessionId",
        };
    }

    let encodedSessionId: string;
    try {
        encodedSessionId = encodeURIComponent(sessionId);
    } catch {
        return {
            callbackUrl: null,
            rdsSessionId: null,
            failureReason: "InvalidRdsSessionId",
        };
    }

    const callbackHost = rdsCallbackHosts[env];
    if (!callbackHost) {
        return {
            callbackUrl: null,
            rdsSessionId: null,
            failureReason: "UnsupportedEnvironment",
        };
    }

    const callbackUrl = new URL(
        `https://${callbackHost}/RedirectionService/CoreRedirection/Callback/${encodedSessionId}`
    );
    Object.entries(queryParameters).forEach(([name, value]) => {
        callbackUrl.searchParams.set(name, value);
    });

    return {
        callbackUrl: callbackUrl.href,
        rdsSessionId: sessionId,
    };
}
